import { isNotFalsy } from "@flaminem/utils";
import { FC } from "react";

import { Highlight } from "src/components/Highlight/Highlight.tsx";
import { findTargetElement } from "src/dynamic-view-renderer/Widgets/WidgetProperties/widgetProperties.utils";
import { useFormatPropertyValue } from "src/hooks/property/useFormatProperty";

import { HeadlessWidgetProps } from "./HeadlessWidget.typings";

export const ConcatenationWidget: FC<HeadlessWidgetProps> = ({ widget, data, searchTerm }) => {
  const formatPropertyValue = useFormatPropertyValue();

  if (widget.type !== "concatenation") return null;

  const { properties, separator = " ", elementPath, prefix = "", suffix = "" } = widget;

  const targetElement = findTargetElement(data.elements, elementPath);

  const propertyValues =
    targetElement && "properties" in targetElement ? targetElement.properties : data.propertyValues;

  if (!propertyValues) return null;

  const values = properties
    .map((prop) => {
      const propertyValue = propertyValues.find((pv) => pv.property.code === prop);
      return propertyValue ? formatPropertyValue(propertyValue) : "";
    })
    .filter(isNotFalsy);

  if (values.length === 0) return <>-</>;

  const result = `${prefix}${values.join(separator)}${suffix}`;
  return searchTerm ? (
    <Highlight term={searchTerm} text={result} className="truncate text-sm" />
  ) : (
    <div className="truncate text-sm">{result}</div>
  );
};
